export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const APP_ADD_DISABLED = 'appAdDisabled';

        const noThanksLink = element.querySelector('[data-action=nothanks]');
        const yesPleaseLink = element.querySelector('[data-action=yesplease]');

        init();
        return {
            hideBanner: hideBannerForever,
        };

        function init() {
            noThanksLink.addEventListener('click', hideBannerForever);
            yesPleaseLink.addEventListener('click', appInstallSelected);
            if (isDisabled()) {
                hideBanner();
            } else {
                if (!('localStorage' in window)) {
                    noThanksLink.classList.add('hidden');
                }
                showBanner();
            }
        }

        function hideBanner() {
            element.classList.add('hidden');
        }

        function showBanner() {
            element.classList.remove('hidden');
        }

        function appInstallSelected() {
            hideBannerForever();
            trackingService.trackLaterObj({
                analyticsName: 'promotion.go-to-app-store.click',
                stringValue: 'messaging',
                eventFlags: 'start,ltp',
            });
        }

        function hideBannerForever() {
            if ('localStorage' in window) {
                try {
                    window.localStorage.setItem(APP_ADD_DISABLED, 'done');
                } catch (e) {}
            }
            hideBanner();
        }

        function isDisabled() {
            if ('localStorage' in window) {
                try {
                    return (
                        window.localStorage.getItem(APP_ADD_DISABLED) === 'done'
                    );
                } catch (e) {
                    return false;
                }
            }
            return false;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxAppAd.js